module.exports = __webpack_public_path__ + "static/media/proj15_img1.5ddae39b.jpg";